import {
  Box,
  Card, Icon, IconButton,
  styled
} from '@mui/material';
import { Link } from 'react-router-dom';

import {
  Avatar,
  Table,
  Tag
} from "antd"

import moment from "moment"
// import { dataSort } from '../../../helper/misc';
import { useState } from 'react';
import { useGetRecentAddedVendor } from '../../../requests/seller';

const CardRoot = styled(Card)(({ theme }) => ({
  marginBottom: '24px',
  padding: '24px !important',
  [theme.breakpoints.down('sm')]: { paddingLeft: '16px !important' },
}));



const CardHeader = styled(Box)(() => ({
  display: 'flex',
  paddingLeft: '24px',
  paddingRight: '24px',
  marginBottom: '12px',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

const Title = styled('span')(() => ({
  fontSize: '1rem',
  fontWeight: '500',
  textTransform: 'capitalize',
}));

const UpgradeCard = () => {


  const { data } = useGetRecentAddedVendor({ limit: 5 });


  const columns = [
    {
      title: 'Logo',
      dataIndex: 'logo',
      key: 'logo',
      width: 30,
      render: logo => <Avatar size={30} src={logo} />
    },
    {
      title: 'Shop',
      dataIndex: 'shop_name',
      key: 'shop_name',
    },
    {
      title: 'Date',
      dataIndex: 'reg_date',
      key: 'reg_date',
      width: 150,
      render: date => <>{moment(date).format('DD-MM-YYYY')}</>
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: status => <Tag color={status === 'approved' ? 'green' : ''}>{status}</Tag>
    },
    {
      title: 'View',
      dataIndex: 'id',
      key: 'id',
      width: 30,
      render: id => <Link to={`/seller_detail/${id}`}>
        <IconButton>
          <Icon color="primary">info</Icon>
        </IconButton>
      </Link>
    },
  ];

  return (
    <CardRoot>
      <CardHeader>
        <Title>Recent Register Sellers</Title>
      </CardHeader>
      <Box overflow="auto">
        <Table dataSource={data?.sellers || []} columns={columns} pagination={false} />;
      </Box>
    </CardRoot>
  );
};

export default UpgradeCard;
